export const ROUTER = {
  HOME: {
    key: 'home',
    name: 'Home',
    path: '/',
    isPrivate: false,
  },
  PRODUCT: {
    key: 'product',
    name: 'Product',
    path: '/product',
    isPrivate: false,
  },
  LOGIN: {
    key: 'login',
    name: 'Login',
    path: '/login',
    isPrivate: false,
  },

  PRODUCTDETAIL: {
    key: 'productDetail',
    name: 'productDetail',
    path: '/product/:id',
    isPrivate: false,
  },
  CART: {
    key: 'cart',
    name: 'cart',
    path: '/cart',
    isPrivate: false,
  },
  PRODUCTBYSUB: {
    key: 'productsub',
    name: 'productsub',
    path: '/productsub/:id',
    isPrivate: false,
  },
  PURCHASEHISTORY: {
    key: 'purchase-history',
    name: 'purchasehistory',
    path: '/purchase-history',
    isPrivate: false,
  },
  SELLERSPAGE: {
    key: 'sellerspage',
    name: 'sellerspage',
    path: '/sellerspage',
    isPrivate: false,
  },
  SEARCHPAGE: {
    key: 'searchpage',
    name: 'searchpage',
    path: '/searchpage',
    isPrivate: false,
  },
  REGISTER: {
    key: 'register',
    name: 'register',
    path: '/register',
    isPrivate: false,
  },
  REGISTERSELLER: {
    key: 'registerSeller',
    name: 'registerSeller',
    path: '/register-seller',
    isPrivate: false,
  },
  RESETPASSWORD: {
    key: 'resetPassword',
    name: 'resetPassword',
    path: '/reset-password',
    isPrivate: false,
  },
  RESULTPAYMENT: {
    key: 'result-payment',
    name: 'result-payment',
    path: '/result-payment',
    isPrivate: false,
  },
  PROFILE: {
    key: 'profile',
    name: 'profile',
    path: '/profile',
    isPrivate: false,
  },
}
